import React, { Component } from "react";
import { Navbar } from "react-bootstrap";
import logo from "assets/img/reactlogo.svg";

import HeaderLinks from "./HeaderLinks.jsx";

import dashboardRoutes from "routes/dashboard.jsx";

class Header extends Component {
  constructor(props) {
    super(props);
    this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this);
    this.state = {
      sidebarExists: false
    };
  }
  mobileSidebarToggle(e) {
    if (this.state.sidebarExists === false) {
      this.setState({
        sidebarExists: true
      });
    }
    e.preventDefault();
    document.documentElement.classList.toggle("nav-open");
    var node = document.createElement("div");
    node.id = "bodyClick";
    node.onclick = function() {
      this.parentElement.removeChild(this);
      document.documentElement.classList.toggle("nav-open");
    };
    //document.body.appendChild(node);
  }
  getBrand() {
    var name;
    dashboardRoutes.map((prop, key) => {
      if (prop.collapse) {
        prop.views.map((prop, key) => {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
          return null;
        });
      } else {
        if (prop.redirect) {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
        } else {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
        }
      }
      return null;
    });
    return name;
  }
  render() {
    return (
      <Navbar fluid>
        <Navbar.Header>
          {this.props.userData ? (
            <React.Fragment>
              <Navbar.Brand>
                <a style={{ textAlign: "center" }} href="#pablo">
                  {/* <span className="logo-img simple-text logo-normal text-center">
                    <img
                      src={logo}
                      alt="logo logo_image"
                      style={{ height: 30, padding: 5 }}
                    />
                  </span> */}
                  {this.getBrand()}
                </a>
              </Navbar.Brand>
              <Navbar.Toggle onClick={this.mobileSidebarToggle} />
            </React.Fragment>
          ) : (
            <div className="logo-img simple-text logo-normal text-center">
              <img
                src={logo}
                alt="logo logo_image"
                style={{ height: 50, padding: 5 }}
              />
            </div>
          )}
        </Navbar.Header>
        <Navbar.Collapse>
          <HeaderLinks
            userData={this.props.userData}
            logout={this.props.logout}
          />
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx